import SelectController from "@/common/components/SelectController"
import { useCompanyUsers } from "@/common/hooks/queries/useCompanyUsers"
import useDebounce from "@/common/hooks/useDebounce"
import { Mapper } from "@/common/services/mapper"
import { CompanyUserData } from "@/features/privateCompanies/types/companyUsers.type"
import { MasterClientUserProps } from "../../types/masterClientUser.type"

export const MasterClientUser = ({
  companyId,
  errors,
  control,
}: MasterClientUserProps) => {
  const [search, setSearch] = useDebounce('')

  const { data: companyUserOptions } = useCompanyUsers({
    filters: {
      search,
      companyId: companyId || '',
    },
    mapper: Mapper.mapToOptions<CompanyUserData>({ labelFieldName: 'full_name', valueFieldName: 'id' }),
  })

  return (
    <div className="flex flex-col gap-4">
      <p className="font-bold text-lg">Responsável</p>
      <SelectController
        control={control}
        name="master_client_user_id"
        label='Gestor de frota'
        markAsRequired
        errorMessage={errors?.master_client_user_id?.message || undefined}
        onInputChange={(newValue) => setSearch(newValue)}
        options={companyUserOptions || []}
      />
    </div>
  );
};
